import { newsApi } from './api'
import { FORGOT_ENDPOINT, LOGIN_ENDPOINT } from "./apiConstant";

export const authApi = newsApi.injectEndpoints({
    endpoints: (build) => ({
        login: build.mutation({
            query: (credentials) => ({
                url: `auth/signin`,
                method: 'POST',
                body: credentials,
                headers: {
                    'Accept': 'application/json',
                },
            }),
            invalidatesTags: ['Profile'],
        }),
        forgot: build.mutation({
            query: (form) => ({
                url: `auth/forgot-password`,
                method: 'POST',
                body: form,
                headers: {
                    'Accept': 'application/json',
                },
            }),
        }),
        verify: build.mutation({
            query: (form) => ({
                url: `verify-otp`,
                method: 'POST',
                body: form,
                headers: {
                    'Accept': 'application/json',
                },
            }),
        }),
        reset: build.mutation({
            query: (form) => ({
                url: `auth/reset-password`,
                method: 'POST',
                body: form,
                headers: {
                    'Accept': 'application/json',
                },
            }),
        }),
    }),
    overrideExisting: false,
})

export const { useLoginMutation, useForgotMutation, useVerifyMutation, useResetMutation } = authApi